import React from "react";
import Echeque from "../../components/E-check/Echeque";


export default function () {
  return (
    <Echeque />
  );
}
